enum FileNodeStatus {
  CREATED = 'CREATED',
  PROCESSING = 'PROCESSING',
  READY = 'READY',
  INVALID = 'INVALID',
  ERRORED_IN_PROCESSING = 'ERRORED_IN_PROCESSING',
}
export default FileNodeStatus;
